module.exports = __webpack_public_path__ + "static/residential-photo-7dbe71a16db905db5b182935f05eb2d2.jpg";